import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import './sheet.css';

/**
 * Τιμή που δεν αλλάζει από εδώ (Επωνυμία, ΑΦΜ): κείμενο με κλειδαριά, όχι γκρι ανενεργό πεδίο —
 * διαβάζεται καλύτερα και δεν μοιάζει με κάτι που «χάλασε». Ομάδα με όνομα την ετικέτα.
 */
export interface SheetLockedProps {
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
  className?: string;
}

export const SheetLocked: React.FC<SheetLockedProps> = ({ label, value, hint, className = '' }) => {
  const { t } = useTranslation(['settings']);
  const uid = useId();
  const labelId = `${uid}-label`;
  const hintId = hint ? `${uid}-hint` : undefined;
  const empty = value === null || value === undefined || value === '';
  return (
    <div className={`xs-locked ${className}`.trim()} role="group" aria-labelledby={labelId} aria-describedby={hintId}>
      <span id={labelId} className="xs-locked-label">{label}</span>
      <span className="xs-locked-value">
        <span>{empty ? '—' : value}</span>
        <Lock aria-hidden="true" />
        <span className="sr-only"> ({t('settings:sheet.locked')})</span>
      </span>
      {hint && <p id={hintId} className="xs-field-hint">{hint}</p>}
    </div>
  );
};

export default SheetLocked;
